/** Systems operate on the World once per simulation tick. The Scheduler runs
 * them in a fixed, declared order (deterministic). */
import type { Tick, Prng, EventBus } from '@settlers/shared';
import type { World } from '../ecs/world.js';
import type { GameMap } from '../map/gamemap.js';
import type { NavGrid } from '../pathfinding/navGrid.js';
import type { RoadNetwork } from '../roads/roadNetwork.js';

/** Everything a system may read/use during a tick. Deterministic inputs only —
 * no wall-clock time, no Math.random. */
export interface SimContext {
  readonly world: World;
  readonly map: GameMap;
  readonly nav: NavGrid;
  readonly roads: RoadNetwork;
  readonly prng: Prng;
  readonly events: EventBus;
  readonly tick: Tick;
}

export interface System {
  readonly name: string;
  update(ctx: SimContext): void;
}

export class Scheduler {
  private readonly systems: System[] = [];

  add(system: System): this {
    this.systems.push(system);
    return this;
  }

  run(ctx: SimContext): void {
    for (const system of this.systems) {
      system.update(ctx);
    }
  }

  get names(): readonly string[] {
    return this.systems.map((s) => s.name);
  }
}
